module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/look-inside-a2567c082728403c899476d720f90e4f.jpg";